/* MiniKin theme - page pieces: hero carousel, tilt, loop, vote, filters, product gallery */
(() => {
  'use strict';
  if (!window.MK) return;
  const { $, $$, reduce, fine, EASE, io } = window.MK;

  /* hero carousel: 6s auto-advance with progress dot */
  const hero = $('[data-hero]');
  if (hero) {
    const sl = $$('[data-slide]', hero), dots = $$('[data-dot]', hero), shapes = $$('[data-shape]', hero);
    let i = 0, t = 0, paused = false, hold = false, x0 = null;
    const tick = () => {
      clearTimeout(t); hero.classList.remove('run');
      if (paused || hold || reduce || sl.length < 2) return;
      void hero.offsetWidth; hero.classList.add('run');
      t = setTimeout(() => go(i + 1), 6000);
    };
    const go = (n) => {
      i = (n + sl.length) % sl.length;
      sl.forEach((s, k) => { s.classList.toggle('is-active', k === i); k === i ? s.removeAttribute('inert') : s.setAttribute('inert', ''); });
      dots.forEach((d, k) => { d.classList.toggle('is-active', k === i); d.setAttribute('aria-selected', k === i); });
      shapes.forEach((s, k) => s.classList.toggle('is-active', k === i));
      hero.style.setProperty('--hero-bg', sl[i].dataset.bg);
      tick();
    };
    hero.addEventListener('click', (e) => {
      const d = e.target.closest('[data-dot]');
      if (d) return go(dots.indexOf(d));
      if (e.target.closest('[data-hero-prev]')) return go(i - 1);
      if (e.target.closest('[data-hero-next]')) return go(i + 1);
      const p = e.target.closest('[data-hero-pause]');
      if (p) { paused = !paused; hero.classList.toggle('is-paused', paused); p.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow'); p.setAttribute('aria-pressed', paused); tick(); }
    });
    if (fine) { hero.addEventListener('mouseenter', () => { hold = true; tick(); }); hero.addEventListener('mouseleave', () => { hold = false; tick(); }); }
    hero.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 50) go(i + (dx < 0 ? 1 : -1)); }, { passive: true });
    go(0);
  }

  /* product card tilt (desktop, fine pointer) */
  if (fine && !reduce) $$('[data-tilt]').forEach((el) => {
    el.addEventListener('pointermove', (e) => {
      const r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      el.style.transition = 'transform .15s';
      el.style.transform = 'perspective(900px) rotateX(' + -y * 6 + 'deg) rotateY(' + x * 6 + 'deg) translateY(-4px)';
    });
    el.addEventListener('pointerleave', () => { el.style.transition = 'transform .4s ' + EASE; el.style.transform = ''; });
  });

  /* details loop pause button */
  $$('[data-loop-toggle]').forEach((lt) => lt.addEventListener('click', () => {
    const off = lt.closest('[data-loop]').classList.toggle('loop-off');
    lt.setAttribute('aria-pressed', off); lt.setAttribute('aria-label', off ? 'Play the moving cards' : 'Pause the moving cards');
  }));

  /* vote for the next character */
  const vg = $('[data-vote-grid]');
  if (vg) {
    const VK = 'mk-vote';
    const mark = (id) => { vg.classList.add('voted'); $$('[data-vote-id]', vg).forEach((a) => a.classList.toggle('is-mine', a.dataset.voteId === id)); };
    let v = null; try { v = localStorage.getItem(VK); } catch (e) {}
    if (v) mark(v);
    vg.addEventListener('click', (e) => {
      const b = e.target.closest('[data-vote]'); if (!b) return;
      const id = b.closest('[data-vote-id]').dataset.voteId;
      try { localStorage.setItem(VK, id); } catch (e2) {}
      mark(id);
    });
  }

  /* collection filter chips */
  const grid = $('[data-grid]');
  if (grid) {
    const chips = $$('[data-filter]'), items = $$('[data-item]', grid);
    const has = (it, f) => (it.dataset.tags || '').split(' ').includes(f);
    const apply = (f, quick) => {
      chips.forEach((c) => c.setAttribute('aria-pressed', c.dataset.filter === f));
      const run = () => {
        let n = 0;
        items.forEach((it) => {
          const on = f === 'all' || has(it, f);
          it.hidden = !on;
          if (on) { it.classList.remove('in'); it.style.setProperty('--d', Math.min(n, 8) * 40 + 'ms'); n++; }
        });
        $$('[data-hide-on-filter]', grid).forEach((b) => { b.hidden = f !== 'all'; });
        const ct = $('[data-count-text]'); if (ct) ct.textContent = n + (n === 1 ? ' item' : ' items');
        grid.classList.remove('is-out');
        requestAnimationFrame(() => requestAnimationFrame(() => items.forEach((it) => !it.hidden && it.classList.add('in'))));
      };
      if (quick) run(); else { grid.classList.add('is-out'); setTimeout(run, 160); }
    };
    chips.forEach((c) => c.addEventListener('click', () => {
      const f = c.dataset.filter, u = new URL(location.href);
      f === 'all' ? u.searchParams.delete('filter') : u.searchParams.set('filter', f);
      history.replaceState(null, '', u); apply(f);
    }));
    /* a link can also filter by a product tag that has no chip of its own, e.g. ?filter=gifts
       from the "Shop gifting" hero button; tapping "All" brings everything back */
    const f0 = new URL(location.href).searchParams.get('filter');
    if (f0 && (chips.some((c) => c.dataset.filter === f0) || items.some((it) => has(it, f0)))) apply(f0, true);
  }

  /* product page: gallery cross-fade, hover zoom, sticky buy bar */
  const main = $('[data-main-img]');
  if (main) {
    const thumbs = $$('[data-thumb]');
    thumbs.forEach((b) => b.addEventListener('click', () => {
      thumbs.forEach((x) => x.setAttribute('aria-current', x === b));
      const swap = () => {
        main.removeAttribute('srcset'); main.src = b.dataset.thumb; main.alt = b.dataset.alt || main.alt;
        if (!reduce) main.animate([{ opacity: 0, scale: 0.97 }, { opacity: 1, scale: 1 }], { duration: 300, easing: EASE });
      };
      reduce ? swap() : main.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 150 }).finished.then(swap);
    }));
    const box = main.parentElement;
    if (fine && !reduce) {
      box.addEventListener('pointermove', (e) => {
        const r = box.getBoundingClientRect();
        main.style.transformOrigin = ((e.clientX - r.left) / r.width) * 100 + '% ' + ((e.clientY - r.top) / r.height) * 100 + '%';
        main.style.transform = 'scale(2)';
      });
      box.addEventListener('pointerleave', () => { main.style.transform = ''; });
    }
    const bm = $('[data-buy-main]'), bb = $('[data-buybar]');
    if (bm && bb && io) new IntersectionObserver(([e]) => bb.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(bm);
  }
})();